/*
* 该JS的目的是 将JS的逻辑统一放到这里处理，处理完再回调给页面
* 使用方法的时候回标注哪里用到该方法，依赖什么方法
* */

import Config from './Config';
import {
	getPayUrl, isInBocApp, isInWeChat, toggleLoading, getUrlParams, stringBoolean, getStorageCache
} from './Utils';
import {
	submit,
	_getUserInfo, searchRewardRecord, getAllProductList, collectionUserAction, checkEventCollect
} from './Rescource';
import history from "../../router/history";
import CommonTipsComponent from "../../components/CommonTipsComponent";
import ToastComponent from "../../components/ToastComponent/ToastComponent";
import TipsComponent from "../../components/TipsComponent/TipsComponent";
import WechatShareUtil from "./wechatShare";
import WeChatShareModule from "../../components/WeChatShareModule/WeChatShareModule";
import listenEvent from './events';
import Api from "./Api";
import ChangePassWordComponent from "../../components/ChangePassWordComponent/ChangePassWordComponent";
import LoginBeforeConfirm from "../../components/LoginBeforeConfirm/LoginBeforeConfirm";
import dayjs from 'dayjs'

/**
 * 过滤支付信息
 * @param arr
 * @return {[]}
 */
function filterPayMethods() {
	// APP环境：paymentMethodId: "BOCPAY",paymentSubMethodId: "BOC_H5"
	// 非APP环境：paymentMethodId: "BOCPAY",paymentSubMethodId: "BOC_EXTERNAL"
	let payArr = []
	if (isInBocApp()) {
		payArr.push({
			paymentMethodId: 'BOCPAY',
			paymentSubMethodId: 'BOC_H5'
		})
	} else {
		payArr.push({
			paymentMethodId: 'BOCPAY',
			paymentSubMethodId: 'BOC_EXTERNAL'
		})
	}
	return payArr
}

/***
 * 提交订单
 * @param productInfo 商品信息
 * @param quantity 商品数量
 * @param payInfo 支付方式
 * @param couponInfo 优惠券信息
 * @return void
 */
function paySubmitOrder(productInfo, quantity = 1, payInfo = filterPayMethods()[0], couponInfo = null) {
	let {userId, token, phoneNum} = _getUserInfo()
	let ext = {
		account: phoneNum
	}
	let {payReturnUrl, unpayReturnUrl} = getPayUrl()
	let coupons = couponInfo ? [{
		couponNo: couponInfo.couponNo,
		couponType: couponInfo.couponMode
	}] : null
	let invoice = null // 发票信息
	let otherProperties = {
		marketing: Object.assign({
			authToken: token,
			authType: Config.authType,
			userId: userId,
			cipherTextNew: Config.cipherTextNew,
		}, (Config.shareOpenId || Config.shareUserId) ? {
			cyAuthType: 'FZS',
			cyOpenId: Config.shareOpenId || '',
			cyUserId: Config.shareUserId || ''
		} : {}),
		schemeNo: Config.schemeNo,
		authType: Config.authType,
		fzsOpenId: Config.fzsOpenId || ''
	}
	let submitData = {
		skuId: productInfo.valueCode,
		// channelSkuId: productInfo.id,
		// channelAccount: productInfo.inputValue,
		num: quantity,
		ext: ext,
		payMethodCode: payInfo.paymentMethodId,
		payMethodSubCode: payInfo.paymentSubMethodId,
		payReturnUrl: payReturnUrl, // 支付成功url
		unpayReturnUrl: unpayReturnUrl, // 支付失败url
		coupons: coupons,
		invoice: invoice,
		otherProperties: otherProperties
	}
	console.log(submitData)
	analysisSubmit('order')
	return submit(submitData).then(res => {
		return res
	}).catch(() => {
		return {success: false}
	})
}

function isNotLoggedIn() { // 判断用户是否登录
	return !Config.loginInfo
}

function clearUserInfo() { // 清空用户登录信息
	Config.loginInfo = null
	window.localStorage.removeItem(`userInfo${Config.channelId}`)
}

/**
 * 全局吐司
 * @param msg
 * @param timeout
 */
function showToast(msg = null, timeout = 2000) {
	let toastDom = CommonTipsComponent({
		Component: ToastComponent,
		props: {
			toastText: msg
		},
		onClose: (type) => {
			return new Promise((resolve) => {
				setTimeout(resolve, 100);
			})
		}
	})
	setTimeout(() => {
		toastDom.close()
	}, timeout)
}


function historyOfPush(name, search = null) { // 统一history跳转 search[String]
	if (!name) return
	let urlSearch = new URLSearchParams(history.location.search)
	let urlParamStr = ''
	if (search) {
		for (let [key, val] of Object.entries(search)) {
			urlSearch.set(key, val)
		}
	}
	urlParamStr = urlSearch.toString()
	history.push({
		pathname: name,
		search: '?' + urlParamStr,
	});
}

function awaitCallback(needWait) {
	return new Promise(resolve => {
		setTimeout(() => {
			resolve(100)
		}, needWait)
	})
}

async function getUserOrderList({state = '', needWait = 0, pageSize = ''}) {
	return new Promise(async (resolve) => {
		if (needWait) {
			toggleLoading(true)
			await awaitCallback(needWait)
		}
		searchRewardRecord({
			state: state,
			pageSize: pageSize
		}).then(res => {
			let obj = {
				code: res.success ? '200' : res.errorCode,
				arr: []
			}
			if (res.success) {
				obj.arr = res.datas
			}
			resolve(obj)
		}).catch(() => {
			resolve({code: '500', arr: []})
		})
	})
}

/**
 * 获取中行用户信息
 * @return {Promise<unknown>}
 */
function returnBocUserInfo() {
	return new Promise(resolve => {
		if (window.c_plugins) {
			window.c_plugins.merchantBridge.judgeLogin(async (data) => {
				if (data.isLogin === 'yes') {
					resolve(await getBocUserInfo())
				} else {
					window.c_plugins.merchantBridge.continueAfterLogin(async (data) => {
						if (data.isCancelLogin === '1') {
							showToast('已经取消登录')
						} else {
							resolve(await getBocUserInfo())
						}
					}, (err) => {
						alert(err.message || err || '网络错误，请检查网络连接');
					}, {})
				}
			}, (err) => {
				alert(err.message || err || '网络错误，请检查网络连接');
			}, {})
		} else {
			setTimeout(() => {
				returnBocUserInfo()
			}, 2000)
		}
	})
}

function getBocUserInfo() {
	return new Promise((resolve) => {
		window.c_plugins.merchantBridge.getBocCustomerAllInfo((userData) => {
			// alert(JSON.stringify(userData.cipherText))
			let userObj = {
				cipherText: ''
			}
			if (userData.cipherText) {
				Config.cipherText = userData.cipherText
				userObj.cipherText = userData.cipherText
			}
			resolve(userObj)
		})
	})
}

// 判断不是白名单
function isNotWhiteList() {
	return new Promise(resolve => {
		getAllProductList({}).then(res => {
			if (res.success) {
				resolve({
					success: true
				})
			} else if (!res.errorCode && !res.datas) { // 非白名单
				resolve({
					error: true,
					code: '4100000'
				})
			} else {
				resolve({
					error: true,
					code: res.errorCode
				})
			}
		}).catch(() => {
			showToast('服务器异常，请稍后重试！')
		})
	})
}

/**
 * 全局Loading
 * @param msg
 */
function showLoading(msg = null) {
	listenEvent.emit('showLoading', msg)
}

/**
 * 关闭全局loading
 */
function hideLoading() {
	listenEvent.emit('hideLoading')
}

/**
 * 弹窗
 * @param msg
 * @param btnText
 * @param needClose{ vm: this，name: methodsName，needClose： true }
 */
function showTipsAlert(msg = null, btnText = null, methods = null, config = null) {
	// let tipsAlert =
	CommonTipsComponent({
		Component: TipsComponent,
		props: {
			text: msg,
			btnText: btnText,
			methods: methods,
			config: config
		},
		onClose: (type) => {
			return new Promise((resolve) => {
				setTimeout(resolve, 100);
			})
		}
	})
}

function randNum(min,max){
	return Math.floor(Math.random() * (max - min + 1) + min);
}

function createShareUrl() {
	let {userId} = _getUserInfo()
	let shareIdStr = (Config.fzsOpenId || userId) ? `?shareOpenId=${Config.fzsOpenId || ''}&shareUserId=${userId || ''}&n=${randNum(0, 9999999999)}` : `?n=${randNum(0, 9999999999)}`
	// const originUrl = 'https://promotion.phone580.com/activity/jh-zh-sl/'
	const originUrl = Config.template.shareWechatUrl || (window.location.origin + window.location.pathname)
	let defaultLink = originUrl + shareIdStr + '#/index'
	return {
		defaultLink,
		shareIdStr
	}
}

function shareInWeChat(injectOption = null) {
	if (!isInWeChat()) return
	let {shareIdStr, defaultLink} = createShareUrl()
	if (injectOption && injectOption.link) {
		injectOption.link = injectOption.link + shareIdStr
	}
	const originUrl = window.location.origin + window.location.pathname
	let imgUrl = 'https://www.phone580.com/xfolder/api/getfile?path=%2Fimgs%2Fhlquan%2Flogo512x512.png'
	if (!Api.isLan) { // 正式环境
		let finallyUrl = originUrl.includes('index') ? originUrl.slice(0, originUrl.indexOf('index')) : originUrl
		finallyUrl = finallyUrl + '/share-icon.jpg'
		imgUrl = finallyUrl
	} else {
		const originUrl = window.location.origin + window.location.pathname
		let finallyUrl = originUrl.includes('index') ? originUrl.slice(0, originUrl.indexOf('index')) : originUrl
		finallyUrl = finallyUrl + '/share-icon.jpg'
	}
	let options = {
		appId: Config.appId,
		link: defaultLink,
		shareMomentsUrl: Config.template.shareMomentsUrl ? Config.template.shareMomentsUrl + shareIdStr + '#/index' : defaultLink,
		imgUrl: imgUrl,
		title: '您有一个福运锦盒待开启',
		desc: '锦鼠报春，点击开启锦盒领惊喜'
	}
	injectOption && (options = Object.assign(options, injectOption));
	console.log(options);
	new WechatShareUtil(options)
}

/**
 * 展示全局微信分享模态框
 */
function showShareModules(userCheckIn) {
	CommonTipsComponent({
		Component: WeChatShareModule,
		props: {
			userCheckIn
		},
		onClose: (type) => {
			return new Promise((resolve) => {
				setTimeout(resolve, 100);
			})
		}
	})
}

/**
 * 从中行分享到微信
 */
function showZhShareModules(pathName, noClooect = false) {
	const {shareIdStr} = createShareUrl()
	const originUrl = Config.template.shareWechatUrl || (window.location.origin + window.location.pathname)
	let shareUrl = originUrl + `${shareIdStr}#${pathName || '/reward'}`
	window.c_plugins.merchantBridge.weixinShare(function () {
		// alert('suc')
	}, function (err) {
		alert(err.message || err || '网络错误，请检查网络连接');
	}, {
		url: shareUrl,
		title: '您有一个福运锦盒待开启',
		description: '锦鼠报春，点击开启锦盒领惊喜',
		img: ''
	})
	if (noClooect) return
	collectionUserAction({
		actionParams: {
			actionNo: Config.shareActionNo,
			actionCode: ''
		},
		voucherParams: {
			voucherKey: 'openId',
			voucherValue: Config.fzsOpenId
		}
	})
	!isNotLoggedIn() && checkEventCollect()
}

/**
 * 获取中行授权，成功后再去获取蜂助手授权
 */
function getAuthorize(type) {
	let notLink = getUrlParams(history.location.search, 'notLink')
	let hrefUrl = window.location.origin + window.location.pathname + `?link=${type}&a=1`
	let bocUrl = "https://cloud.bankofchina.com/gd/weixin/wxOAuth2.do?method=wxOAuth2Forword3&dispatchParam=" + hrefUrl + "?islog=true&scope=snsapi_base"
	// let fzsString = getUrlParams(history.location.search, 'fzs')
	if (isInWeChat()) {
		if (!(notLink || Config.bocOpenId)) {
			window.location.replace(bocUrl)
		} else if (!Config.goFzsAuthorize || !Config.fzsOpenId) { // !((fzsString && stringBoolean(fzsString)) || Config.fzsOpenId)
			getFzsAuthorize(type)
		} else {
			return true
		}
	} else {
		return true
	}
}

/**
 * 蜂助手授权
 * @param type
 */
function getFzsAuthorize(type) {
	let url = ''
	let {frontPage, rewardPage} = Config.template
	if (type === 'index' && frontPage) { // 模板首页
		url = frontPage
	} else if (type === 'reward' && rewardPage) { // 模板领奖页
		url = rewardPage
	} else {
		if (window.location.href.includes('6688')) { // 本地
			url = Config.fzsAuthorizeDev[type]
		} else if (window.location.href.includes('test.s.phone580.com')) { // 测试
			url = Config.fzsAuthorizeTest[type]
		} else {
			url = Config.fzsAuthorizeUrl[type]
		}
	}
	// else if (window.location.href.includes('test/activity/')) { // 灰度
	// 	url = Config.fzsAuthorizeGray[type]
	// }
	window.location.replace(url)
}

/**
 * 展示改密规则弹窗
 */
function showPassWordModules(type) {
	CommonTipsComponent({
		Component: ChangePassWordComponent,
		props: {
			type: type
		},
		onClose: (type) => {
			return new Promise((resolve) => {
				setTimeout(resolve, 100);
			})
		}
	})
}

/**
 * 1123213
 */
function showPassWordLogin() {
	CommonTipsComponent({
		Component: LoginBeforeConfirm,
		onClose: (type) => {
			return new Promise((resolve) => {
				setTimeout(resolve, 100);
			})
		}
	})
}

function userSelectArrReceive($this, userPayReward, userShareReward) {
	let events = {}
	if (userPayReward.length) {
		events = {
			msg: '你有礼品待领取，快来领取吧～',
			btnText: '领取',
			methods: {
				vm: $this,
				name: 'linkReward',
				needClose: $this
			},
			config: {
				name: 'showReceiveShareReward'
			}
		}
	} else { // 这是分享的奖品
		events = {
			msg: '你当前有待领取的礼品哦~',
			btnText: isInWeChat() ? '一键领取' : '分享到微信领取',
			methods: null,
			config: {
				vm: $this,
				name: 'receiveShareReward',
				data: userShareReward
			}
		}
	}
	showTipsAlert(events['msg'], events['btnText'], events['methods'], events['config'])
}

// 统计提交订单事件
function analysisSubmit(type) {
	try {
		let {userId, phoneNum} = _getUserInfo()
		let analyInfo = {
			submit_result: type === 'order' ? `订单下单` : '开奖',
			date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
			account: `${phoneNum}`,
			userId: userId,
			fzsOpenId: Config.fzsOpenId,
			bocOpenId: Config.bocOpenId,
			shareOpenId: Config.shareOpenId,
			shareUserId: Config.shareUserId,
		}
		if (type === 'order') {
			window.$analysis.trackEvent('order', 'submit', JSON.stringify(analyInfo))
		} else {
			window.$analysis.trackEvent('openPrize', 'openPrize', JSON.stringify(analyInfo))
		}
	} catch (e) {
		console.log(e)
	}
}

export {
	historyOfPush,
	filterPayMethods, // 过滤支付信息
	paySubmitOrder, // 提交订单
	isNotLoggedIn, // 判断用户是否登录
	clearUserInfo, // 清空用户登录信息
	getUserOrderList, // 统一获取用户可领取的订单列表
	returnBocUserInfo, // 封装好的中行获取用户信息方法
	isNotWhiteList, // 判断不是白名单
	showToast, // 全局吐司
	showLoading, // 开启全局loading
	hideLoading, // 关闭全局loading
	showTipsAlert, // 全局图片弹窗
	createShareUrl, // 获取分享的url
	shareInWeChat, // 微信分享
	showShareModules, // 展示全局微信分享模态框
	showZhShareModules, // 从中行分享到微信
	getAuthorize, // 获取中行授权，成功后再去获取蜂助手授权
	showPassWordModules, // 展示改密规则弹窗
	showPassWordLogin, //
	userSelectArrReceive, // 用户有可领取或领取失败的奖品（支付红包、分享红包）
	analysisSubmit, // 订单统计
}
